export const stepOneData = [
  {
    heading: "Why Use MinEMI’s EMI Calculator for Car Loan Balance Transfers?",
    // paras before heading

    infoList: [
      {
        heading: " Accurate EMI Estimates: ",
        description:
          "Get precise calculations for your new EMIs based on updated loan terms.",
      },
      {
        heading: " Evaluate Savings Instantly:  ",
        description:
          " Understand how much you can save by switching to a lower interest rate.",
      },
      {
        heading: " Compare Lenders: ",
        description:
          "Find the best loan offers with competitive rates and flexible terms.",
      },
      {
        heading: " Simple and Transparent:   ",
        description:
          " MinEMI provides clarity on costs, including transfer fees and savings.",
      },
      {
        heading: "Time-Saving Tool:  ",
        description:
          "Get results in seconds and make informed decisions quickly.",
      },
    ],
    headingTwo:
      "What You Can Do With the Car Loan Balance Transfer EMI Calculator?",
    // paras before heading

    infoListTwo: [
      {
        heading: "Estimate Your New EMI:",
        description:
          "Input your outstanding loan amount, current and new interest rates, and remaining tenure to calculate your revised EMI instantly.",
      },
      {
        heading: " Compare Loan Offers: ",
        description:
          "Adjust variables to see how different lenders’ offers impact your EMI and total repayment costs.",
      },
      {
        heading: "Understand Savings:",
        description:
          "See the difference between your current car loan costs and the potential savings from a balance transfer.",
      },
    ],
    minEmiTipHead: "Transfer Early for Maximum Savings",
    minemiTip: [
      {
        head: "Early Tenure:",
        info: "Balance transfers are most beneficial when done early in the loan tenure as the interest component is higher in the",
      },
      {
        head: "Market Trends:",
        info: " Keep an eye on interest rate reductions and transfer at the right time.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    minEmiTipHead: "Account for Processing Fees",
    minemiTip: [
      {
        info: " Most lenders charge a processing fee of 0.5%-2% of the loan amount for balance transfers.",
      },
      {
        info: " Ensure that your savings exceed these costs before proceeding with the transfer.",
      },
    ],
    heading: "How to Maximize Savings on Your Car Loan EMI",

    infoList: [
      {
        heading: "Compare Interest Rates:",
        info: "Even a small reduction in the interest rate can lead to significant savings over the loan tenure.",
      },
      {
        heading: "Choose the Right Tenure:",
        info: "Opt for a tenure that balances EMI affordability and total repayment costs.",
      },
      {
        heading: "Prepayment Options:",
        info: "Use MinEMI’s Prepayment Calculator to check how lump-sum payments can reduce your principal and EMIs.",
      },
    ],

    minEmiTipHeadTwo: " Evaluate Your Financial Profile",
    minemiTipTwo: [
      {
        head: " Credit Score:",
        info: "A high credit score can help you qualify for lower interest rates.",
      },
      {
        head: " Debt-to-Income Ratio:",
        info: "Ensure that your overall EMIs are manageable within your monthly income.",
      },
    ],

    paraOne: "Take Control of Your Car Loan with MinEMI",
    paraTwo:
      "With MinEMI’s Car Loan Balance Transfer EMI Calculator, you can confidently manage your repayments, reduce EMIs, and save significantly. Start calculating today and take the first step toward financial freedom!",
  },
];
